module.exports = __webpack_public_path__ + "static/media/ProfileDefaultIconResultScore.44701aab.svg";